import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["DarkModeSyncer"] */ "/vercel/path0/components/dark-mode-syncer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TabManager"] */ "/vercel/path0/components/tab-manager.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/ui/toaster/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ApolloWrapper"] */ "/vercel/path0/lib/client/apollo-client-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PHProvider"] */ "/vercel/path0/modules/analytics/post-hog-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogPageView","PostHogAuthenticate"] */ "/vercel/path0/modules/analytics/post-hog-view.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthManager"] */ "/vercel/path0/modules/auth/auth-manager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/vercel/path0/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager", webpackExports: ["SpeedInsights"] */ "/vercel/path0/node_modules/@vercel/speed-insights/dist/next/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"modules/app/constants.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-inter\",\"weight\":[\"400\",\"500\",\"600\",\"700\"]}],\"variableName\":\"inter\"}");
